import {getAutoSaverConfig} from './AutoSaverConfig';

const AUTO_SAVER_CONFIG = getAutoSaverConfig();

export const SAVE_INTERVAL = AUTO_SAVER_CONFIG.saveInterval;
export const MAX_STALE = AUTO_SAVER_CONFIG.maxStale;
